import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import rootReducer from './rootReducer';
import { persistStore, persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import createSagaMiddleware from 'redux-saga';
import { seamlessImmutableReconciler } from 'redux-persist-seamless-immutable'
import ImmutablePersistenceTransform from './ImmutablePersistenceTransform'
import rootSaga from '../sagas';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import history from './history'


var store = null;
var persistor = null;

var sagaMonitor = null
var sagaMiddleWare = createSagaMiddleware({ sagaMonitor })

export default {
    configureStore() {
        var middleWare = [];
        middleWare.push(routerMiddleware(history))
        middleWare.push(sagaMiddleWare)

        const persistConfig = {
            key: 'spark-persist-config',
            storage: storageSession,
            stateReconciler: seamlessImmutableReconciler,
            transforms: [ImmutablePersistenceTransform],
            whitelist: ['configuration', 'router'],
            blacklist: ['error']
        }

        const logFilter = (getState, action) => {
            switch (action.type) {
                case 'SET_ERROR_DATA':
                    return false;
                default:
                    return true;
            }
        }
        const logger = createLogger({
            predicate: logFilter
        })
        middleWare.push(logger)

        const persistedReducer = persistReducer(persistConfig, rootReducer(history))
        const routerReducer = connectRouter(history)(persistedReducer)

        store = createStore(routerReducer, applyMiddleware(...middleWare));
        persistor = persistStore(store)

        sagaMiddleWare.run(rootSaga);
        return store;
    },
    getStore() {
        return store;
    },
    getPersistor() {
        return persistor;
    },
    getHistory() {
        return history;
    }
};
